// extracted by mini-css-extract-plugin
export var cardHeader = "_u0-0";
export var reorderHandle = "_u0-3";
export var titleArea = "_u0-1";
export var titleAreaWithHandle = "_u0-2";